import(/* webpackMode: "eager", webpackExports: ["Hydrate","useHydrate"] */ "/app/node_modules/@tanstack/react-query/build/lib/Hydrate.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/app/node_modules/@tanstack/react-query/build/lib/isRestoring.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["QueryClientProvider","defaultContext","useQueryClient"] */ "/app/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/app/node_modules/@tanstack/react-query/build/lib/QueryErrorResetBoundary.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["unstable_batchedUpdates"] */ "/app/node_modules/@tanstack/react-query/build/lib/reactBatchedUpdates.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/app/node_modules/@tanstack/react-query/build/lib/useIsFetching.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating"] */ "/app/node_modules/@tanstack/react-query/build/lib/useIsMutating.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/app/node_modules/@tanstack/react-query/build/lib/useMutation.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/app/node_modules/@tanstack/react-query/build/lib/useQueries.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/app/node_modules/@tanstack/react-query/build/lib/useQuery.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/shared/ui/typography/typography.tsx\",\"import\":\"Unbounded\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"700\",\"900\"],\"subsets\":[\"latin\",\"cyrillic\"]}],\"variableName\":\"unbounded\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Data"] */ "/app/src/app/(site)/favorites/data.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useEditUserQuery"] */ "/app/src/shared/api/queries/use-edit-user-mutation.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useGetAiPlayerItemQuery"] */ "/app/src/shared/api/queries/use-get-ai-player-item-query.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useGetAiPlayerListQuery"] */ "/app/src/shared/api/queries/use-get-ai-player-list-query.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useGetCommonReviewsPaginatedQuery"] */ "/app/src/shared/api/queries/use-get-common-reviews-paginated-query.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useGetFavoritesQuery"] */ "/app/src/shared/api/queries/use-get-favorites-query.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useGetNoteQuery"] */ "/app/src/shared/api/queries/use-get-note-query.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useGetNotesDynamicDataQuery"] */ "/app/src/shared/api/queries/use-get-notes-dynamic-data-query.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useGetOrderedNotesQuery"] */ "/app/src/shared/api/queries/use-get-ordered-notes-query.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useGetOrdersQuery"] */ "/app/src/shared/api/queries/use-get-orders-query.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useGetQuestionsQuery"] */ "/app/src/shared/api/queries/use-get-questions-query.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useGetReviewsQuery"] */ "/app/src/shared/api/queries/use-get-reviews-query.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useGetUserQuery"] */ "/app/src/shared/api/queries/use-get-user.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useResetPasswordQuery"] */ "/app/src/shared/api/queries/use-reset-password-mutation.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useRunRecognizeVideoMutation"] */ "/app/src/shared/api/queries/use-run-recognize-video-mutation.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useSetPasswordMutation"] */ "/app/src/shared/api/queries/use-set-password-mutation.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useVideoLessonMutation"] */ "/app/src/shared/api/queries/use-video-lesson-mutation.ts");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/green-bg.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/guarantees-bg.png");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/app-store.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/arrow-diagonal-white.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/arrow-diagonal.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/arrow-down.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/chevron-down.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/chevron-up.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/close-dark.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/close.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/dropdown-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/export.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/favorite.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/flag-rus.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/google-play.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/guarantee.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/import.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/like-grey.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/like-red.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/like.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/link.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/logo.png");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/menu.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/note.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/pause.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/payments-ru.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/pinterest.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/play.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/pplay.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/print.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/radiobutton-filled.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/radiobutton.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/remove.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/search.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/setting.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/shopping-cart.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/star-gold.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/star.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/user.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/view.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/vk.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/youtube.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/icons/zoom.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/notes-list.svg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/preview.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/shared/assets/subscribe-bg.png");
;
import(/* webpackMode: "eager", webpackExports: ["AuthContext"] */ "/app/src/shared/libs/auth-context/auth-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyContext"] */ "/app/src/shared/libs/currency-context/currency-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useImageQueue"] */ "/app/src/shared/libs/hooks/use-image-queue.ts");
;
import(/* webpackMode: "eager", webpackExports: ["usePagination"] */ "/app/src/shared/libs/hooks/use-pagination.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useUrlParam"] */ "/app/src/shared/libs/hooks/use-url-param.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ModalContext"] */ "/app/src/shared/libs/modal-context/modal-context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Player"] */ "/app/src/shared/libs/player/player.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/app/src/shared/ui/breadcrumbs/breadcrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/button/button.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/button-expand/button-expand.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/button-figure/button-figure.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/button-icon/button-icon.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/button-back/button-back.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Button","ButtonColor","ButtonSize"] */ "/app/src/shared/ui/button/button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/checkbox/checkbox.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/complexity/complexity.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/container/container.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/divider/divider.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ImageWithFallback"] */ "/app/src/shared/ui/image-with-fallback/image-with-fallback.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/input/input.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/label/label.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/loader/loader.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/menu-action/menu-action.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/shared/ui/modal/modal.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"weight\":[\"700\",\"500\"],\"subsets\":[\"latin\",\"cyrillic\"]}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/modal/model.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PageCard"] */ "/app/src/shared/ui/page-card/page-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/src/shared/ui/pagination/pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PdfViewer"] */ "/app/src/shared/ui/pdf-viewer/pdf-viewer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/radio/radio.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/radio-static/radio-static.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Rating"] */ "/app/src/shared/ui/rating/rating.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewRating"] */ "/app/src/shared/ui/rating/review-rating.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Select"] */ "/app/src/shared/ui/select/select.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubMenu"] */ "/app/src/shared/ui/sub-menu/sub-menu.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/typography/typography.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/stack/stack.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/tab/tab.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/toggle/toggle.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/show-more/show-more.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/static-page-style.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/list.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/link.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/widgets/layout/components/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/widgets/layout/components/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/widgets/layout/layout.module.css");
